import React, { Component } from "react";
import ReactTable from "react-table";
import InputMask from "react-input-mask";
import HttpUtil from "../../Util/httpUtil";
import Config from "../../Util/config";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import "../../_Content/css/modal.css";

class ModalAlerta extends Component {
  constructor(props) {
    super(props);

    this.state = {
      modalVisivel: false,
      mensagemAlerta: "",
      mostrarMensagem: this.props.mostrarMensagem,
      mostrarBotaoSim: this.props.mostrarBotaoSim,
      dadosTabela: this.props.dadosTabela,
      textoBotaoConfirmacao: this.props.textoBotaoConfirmacao,
      textoBotaoNegativo: this.props.textoBotaoNegativo,
      colunas: [
        {
          Header: "UF-ST",
          className: "text-center txt",
          accessor: "uf",
          maxWidth: 100,
          Cell: row => (
            <span className="flexCenter">
              <span>
                {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Pendentes",
          className: "text-center txt",
          accessor: "guiasPendentes",
          maxWidth: 100,
          Cell: row => (
            <span className="flexCenter">
              <span>
                {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Emitidas",
          className: "text-center txt",
          accessor: "guiasEmitidas",
          maxWidth: 100,
          Cell: row => (
            <span className="flexCenter">
              <span>
                {row.value}
              </span>
            </span>
          )
        },
        {
          Header: "Rejeitadas",
          className: "text-center txt",
          accessor: "guiasRejeitadas",
          maxWidth: 100,
          Cell: row => (
            <span className="flexCenter">
              <span>
                {row.value}
              </span>
            </span>
          )
        }
      ]
    };
  }

  alterarVisibilidadeModal = () => {
    this.setState({
      mostrarMensagem: this.props.mostrarMensagem,
      modalVisivel: !this.state.modalVisivel,
      mostrarBotaoSim: this.props.mostrarBotaoSim,
      dadosTabela: this.props.dadosTabela,
      textoBotaoConfirmacao: (this.props.textoBotaoConfirmacao != null && this.props.textoBotaoConfirmacao != "") ? this.props.textoBotaoConfirmacao : "Sim",
      textoBotaoNegativo: (this.props.textoBotaoNegativo != null && this.props.textoBotaoNegativo != "") ? this.props.textoBotaoNegativo : "Não"
    });

    this.forceUpdate();
  };

  botaoClicked = (btnSim) => {
    if (btnSim) {
      this.props.action();
    }
    this.alterarVisibilidadeModal();
  }

  //montarMensagemInicialParaUsuario = () => {
  //	let mensagem = "";

  //	mensagem += "<span>";
  //	mensagem += "	Antes de começarmos, é importante lembrar que este sistema coleta e armazena informações fornecidas por você.";
  //	mensagem += "	</br>";
  //	mensagem += "	É essencial que você tenha certeza de que:";
  //	mensagem += "	</br>";
  //	mensagem += "	<ul>";
  //	mensagem += "		<li>";
  //	mensagem += "			As informações que você fornece são precisas e completas.";
  //	mensagem += "		</li>";
  //	mensagem += "		<li>";
  //	mensagem += "			Você está ciente das políticas de privacidade do sistema.";
  //	mensagem += "		</li>";
  //	mensagem += "		<li>";
  //	mensagem += "			Você é responsável por manter a confidencialidade de suas credenciais de acesso.";
  //	mensagem += "		</li>";
  //	mensagem += "	</ul>";
  //	mensagem += "	</br>";
  //	mensagem += "	Ao confirmar que você concorda com essas responsabilidades, podemos prosseguir.";
  //	mensagem += "	</br>";
  //	mensagem += "	Clique em Continuar para iniciar a experiência.";
  //	mensagem += "</span>";

  //	return mensagem;
  //}

  render() {
    return (
      <div>
        <Modal id="modal-confirmacao" isOpen={this.state.modalVisivel} toggle={this.state.toggle} size="bd-example-modal-sm"
          className={this.props.className}>
          <ModalBody>
            <img src="/img/ecoicos/ecoico-nao-realizada.svg" alt="alerta" />
            <label>Cuidado!</label>
            {/*{this.state.mensagemAlerta}*/}
            <span className="span1">
              {
                this.props.mostrarMensagem == 0 ? this.props.mensagemAlerta :
                  this.props.mostrarMensagem == 1 ?
                    <span>
                      Antes de começarmos, é importante lembrar que este sistema coleta e armazena informações fornecidas por você.
                      <br />
                      É essencial que você tenha certeza de que:
                      <br />

                      <br />
                      Ao confirmar que você concorda com essas responsabilidades, podemos prosseguir.
                      <br />
                      Clique em "Continuar" para iniciar a experiência.
                      <br />
                    </span> :
                    this.props.mostrarMensagem == 2 ?
                      <span>
                        Ops! Parece que algo deu errado...
                        <br />
                        Não foi possível executar a função porque encontramos divergências relacionadas aos Registros no EFD utilizados para a extração dos dados.
                        <br />
                        Segue motivo:
                        <br />
                        <ul>
                          <li>
                            {this.props.mensagemAlerta}
                          </li>
                        </ul>
                        <br />
                        Para solucionar o problema, recomendamos verificar o arquivo EFD e corrigir os erros encontrados apontados pelo EcoAuditor.
                        <br />
                        Para maiores informações, favor contactar nosso <a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank">suporte técnico</a>.;
                      </span > :
                      this.props.mostrarMensagem == 3 ?
                        <span>
                          Seu arquivo foi validado e está pronto para iniciar o processo relacionado ao ICMS por apuração.
                          <br />
                          Você tem certeza que deseja continuar?
                        </span > :
                        this.props.mostrarMensagem == 4 ?
                          <span>
                            Processamento Concluído!
                            <br />
                            O sistema executou com sucesso e os resultados estão disponíveis para visualização.
                            <br />
                            Para visualizar os detalhes de cada guia e realizar as ações necessárias:
                            <br />
                            <ul>
                              <li>
                                <a href="https://gnre.econeteditora.com.br/" target="_blank">Clique aqui</a> para ser redirecionado para o sistema EcoGNRE";
                              </li>
                            </ul>
                            Recomendamos que você analise os resultados com atenção e tome as medidas necessárias para as guias pendentes ou rejeitadas.
                            <br />
                            Em caso de dúvidas, entre em contato com o nosso <a href="https://www.econeteditora.com.br/solucoes/index.php?acao=envio&form[destino]=10&form[area]=34&form[tipo]=6&form[assunto]=413" target="_blank">suporte técnico</a>.";
                            <br />
                            Resumo:
                            <br />
                            {
                              this.state.dadosTabela ?
                                <ReactTable data={this.state.dadosTabela} columns={this.state.colunas} className="eco-react-table"
                                  showPagination={false} pageSize={this.state.dadosTabela.length} /> : null
                            }
                          </span> : null
              }
            </span>
            <div className="optsBox clearfix">
              {
                this.props.mostrarBotaoSim ?
                  <Button className="ecobtn fat vazado baby-blue float-left" onClick={() => this.botaoClicked(true)}>
                    {this.state.textoBotaoConfirmacao}
                  </Button> : null
              }
              <Button className="ecobtn fat vazado vermelho float-right" onClick={() => this.botaoClicked(false)}>
                {this.state.textoBotaoNegativo}
              </Button>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default ModalAlerta;



// WEBPACK FOOTER //
// ./src/Componente/Modulo/ModalAlerta.jsx